module.exports = __webpack_public_path__ + "img/ic_pic.f17900cd.svg";